
import { PublicLandingView } from "../components/PublicLandingView";
import {NYSReport} from "@seims/shared";
import { isAuthenticated, login } from "@seims/shared/src/security";

export const ToggleHomeView = () => {
  return isAuthenticated() ? <NYSReport /> : <PublicLandingView />;
};

export const handleLogin = async () => {
    login({
        redirectUri: `${window.location.origin}`
    });
};
